import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Fade, Slide } from 'react-awesome-reveal';
import  autoAnimate  from '@formkit/auto-animate';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const CourseBanner = () => {
  const parent = useRef(null);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, []);

  return (
    <div
      ref={parent}
      className="relative bg-gradient-to-r from-gray-900 to-gray-800 overflow-hidden h-[30rem] sm:h-[36rem] md:h-96"
    >
      {/* SEO Helmet */}
      <Helmet>
        <title>Racila Softech Pvt Ltd</title>
        <meta
          name="description"
          content="Boost your career with Racila Softech's expert-led courses in AI, Machine Learning, Web Development, Programming, and more. Learn from industry professionals and achieve your goals."
        />
        <meta
          name="keywords"
          content="AI courses, Machine Learning courses, Web Development, Programming, Racila Softech courses, online learning, tech training"
        />
        <meta name="author" content="Racila Softech Pvt Ltd" />
        <meta property="og:title" content="Racila Softech Pvt Ltd" />
        <meta
          property="og:description"
          content="Join our expert-led professional courses and get ahead in AI, Machine Learning, Web Development, and more."
        />
        <meta property="og:url" content="https://racilasoftech.in/courses" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Background image */}
      <img
        src="/images/course/coursebg.webp"
        alt="Courses Banner"
        className="absolute inset-0 w-screen h-full opacity-80 "
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col sm:w-1/2 sm:ml-20 sm:-mt-6 items-center justify-center h-full px-4 sm:px-8 text-center text-white space-y-6">
        <Slide direction="up" triggerOnce>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
            Our Expert-led Courses for your bright future
          </h2>
        </Slide>

        <Fade delay={300} triggerOnce>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-xl">
            Learn from industry professionals. Master skills in AI, ML, Programming, Web Dev & more.
          </p>
        </Fade>

        <Fade delay={500} triggerOnce>
          <div>
            <Link
              to="/courses"
              className="inline-block bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-indigo-700 hover:to-blue-700 text-white text-base sm:text-lg px-5 py-3 rounded-full shadow-lg transition duration-300"
              onClick={scrollToTop}
            >
              Explore Courses
            </Link>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default CourseBanner;
